(function () {
  'use strict';

  angular
    .module('itecAdministracio.productes.main.submain.permisos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('productes.main.submain.permisos', {
        url: '/permisos',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosProductesHeaderSubmenuLinksValue){
                return permisosProductesHeaderSubmenuLinksValue;
              }
            }
          },
          'content@productes.main.submain': {
            templateUrl: 'productes/main/permisos/permisos.tpl.html',
            controller: 'ProductesMainPermisosCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_PRODUCTES_PERMISOS'
      });
  }
}());
